import { apiService } from './api.services.js'

export async function cashierApi(path, method = 'GET', payload) {
  const result = await apiService(`/api/cashier/${path}`, method, payload)
  if (!result || result.err || result.detail || result.error || result.status_code >= 400) {
    const error = new Error(result && (result.err || result.detail || result.error) || 'No pudimos cargar la caja. Intenta actualizar.')
    error.status = result && result.status_code
    throw error
  }
  return result
}

export async function downloadCashierTickets(registerId, sale) {
  // Refresh the session through the shared client before fetching the binary PDF.
  await cashierApi('registers/')
  const token = window.localStorage.getItem('organizer_access_token')
  const response = await fetch(`/api/cashier/registers/${registerId}/sales/${sale.id}/tickets/`, {
    credentials: 'same-origin', headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!response.ok) throw new Error('No pudimos descargar las entradas. Reintenta; la venta ya está cobrada.')
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a')
  link.href = url
  link.download = `fomo-caja-${sale.invoice_id}.pdf`
  link.click()
  window.setTimeout(() => URL.revokeObjectURL(url), 30000)
}
